import styled from 'styled-components';
import background from 'css-images/background-two-teams-сustomizable.jpg';
import {scaleDesktop} from 'styled/scaleDesktop';

interface Props {
  nude?: boolean
}

const radiusWidgetTwoTeamsBodyСustomizable = 5;
const backgroundWidgetTwoTeamsBodyСustomizable = `url(${background}) no-repeat`;

export const WidgetTwoTeamsBodyСustomizable = styled.div<Props>`
  border-radius: ${scaleDesktop(radiusWidgetTwoTeamsBodyСustomizable)};
  position: relative;
  background: ${props => props.nude ? 'none' : backgroundWidgetTwoTeamsBodyСustomizable};
  background-size: 100%;
  width: 100%;
  height: 0;
  padding-top: calc(100% / 2.14);
  overflow: hidden;
`;
